import { useEffect, useState } from 'react';
import { preferredDensity, preloadPieces, type PieceImages } from './sprites.js';

/** How long a board waits for its pictures before it plays the plain grid instead. */
export const ART_WAIT_MS = 4000;

/**
 * A DOM board's pictures: undefined while they load, null when any failed or they took
 * longer than ART_WAIT_MS (the board then plays its plain grid), or every one decoded.
 * A set that arrives after the wait still replaces the plain grid.
 */
export function usePieceArt<K extends string>(game: string, pieces: readonly K[], waitMs = ART_WAIT_MS): PieceImages<K> | null | undefined {
  const [art, setArt] = useState<PieceImages<K> | null | undefined>(undefined);
  useEffect(() => {
    let live = true;
    const wait = setTimeout(() => {
      if (live) setArt((a) => (a === undefined ? null : a));
    }, waitMs);
    void preloadPieces(game, pieces, preferredDensity(globalThis.devicePixelRatio)).then((imgs) => {
      clearTimeout(wait);
      if (live) setArt((a) => imgs ?? (a === undefined ? null : a));
    });
    return () => {
      live = false;
      clearTimeout(wait);
    };
    // The piece list is a module constant per game.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [game]);
  return art;
}
